import gql from 'graphql-tag';
import { UserFeedFollowGroup } from './group';
import PublicUserProfile from './public_user_profile';

export default gql`
  fragment UserFeedFollow on UserFeedFollow {
    feed
    user_id
    created_at
    postable
    group {
      ...UserFeedFollowGroup
    }
    user {
      ...PublicUserProfile
    }
  }
  ${UserFeedFollowGroup}
  ${PublicUserProfile}
`;
